import React, { useEffect } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { metronic, toAbsoluteUrl } from "../../../_metronic";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { saveUserPreferences } from "../../services/usersService";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import Swal from "sweetalert2";

const languages = [
  {
    lang: "en",
    name: "English",
    flag: toAbsoluteUrl("/media/flags/260-united-kingdom.svg"),
  },
  {
    lang: "id",
    name: "Bahasa Indonesia",
    flag: toAbsoluteUrl("/media/flags/209-indonesia.svg"),
  },
];

function LanguageSelector({ iconType, lang }) {
  const { userPreferences, reload, setReload } = useGlobalData();

  useEffect(() => {}, [reload]);

  const currentLanguage = languages.find(
    (x) => x.lang === userPreferences.language
  );
  return (
    <Dropdown
      className="kt-header__topbar-item kt-header__topbar-item--langs"
      drop="down"
      alignRight
    >
      <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-my-cart">
        <span
          className={clsx("kt-header__topbar-icon", {
            "kt-header__topbar-icon--brand": iconType === "brand",
          })}
        >
          <img src={currentLanguage.flag} alt={currentLanguage.name} />
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
        <ul className="kt-nav kt-margin-t-10 kt-margin-b-10">
          {languages.map((language) => (
            <li
              key={language.lang}
              className={clsx("kt-nav__item", {
                "kt-nav__item--active":
                  language.lang === userPreferences.language,
              })}
            >
              <span
                onClick={async () => {
                  saveUserPreferences({
                    ID: userPreferences.ID,
                    userID: userPreferences.userID,
                    lightAsideSkin: userPreferences.lightAsideSkin,
                    darkAsideSkin: userPreferences.darkAsideSkin,
                    lightText: userPreferences.lightText,
                    darkText: userPreferences.darkText,
                    invifoThemeID: userPreferences.invifoThemeID,
                    customThemeID: userPreferences.customThemeID,
                    language: language.lang,
                    menuLayout: userPreferences.menuLayout,
                  }).then((response) => {
                    if (language.lang != "en") {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "For Your Information",
                        text:
                          "Only the English language is available on the platform at this moment. Please stay tuned for more available languages",
                        icon: "info",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                    }
                    setReload(reload + 1);
                  });
                }}
                className={clsx("kt-nav__link", {
                  "kt-nav__link--active":
                    language.lang === userPreferences.language,
                })}
              >
                <span className="kt-nav__link-icon">
                  <img src={language.flag} alt={language.name} />
                </span>
                <span className="kt-nav__link-text">{language.name}</span>
              </span>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const mapStateToProps = ({ i18n }) => ({ lang: i18n.lang });

export default connect(
  mapStateToProps,
  metronic.i18n.actions
)(LanguageSelector);
